import { render, staticRenderFns } from "./POIDeleteConfirm.vue?vue&type=template&id=25726c24&"
import script from "./POIDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./POIDeleteConfirm.vue?vue&type=script&lang=js&"
import style0 from "./POIDeleteConfirm.vue?vue&type=style&index=0&id=25726c24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports